/* eslint-disable camelcase */

/* Naming convention for GA constants: Session_Category_Action */
import config from '../../config';

export const SessionTrackingIds = {
    DDB: config.production
        ? 'UA-26524418-48' // DDB Proper Account
        : 'UA-117447463-5', // Encounter Builder Test Account
};

export const SessionNames = {
    DDB: 'DnDBeyond', // Session names cannot use spaces or special characters
};

export const SessionTrackingIdByName = {
    [SessionNames.DDB]: SessionTrackingIds.DDB,
};

const CategoryPrefix = 'Character Listing';

export const EventCategories = {
    DDB_Character: `${CategoryPrefix} Character Card`,
    DDB_ListingFilter: `${CategoryPrefix} Filter`,
    DDB_ListingSort: `${CategoryPrefix} Sort`,
    DDB_PlayerAppBanner: `${CategoryPrefix} Player App Banner`,
    DDB_Unlock: `${CategoryPrefix} Unlock`,
};

export const EventActions = {
    DDB_Character_Campaign: 'Campaign',
    DDB_Character_Copy: 'Copy',
    DDB_Character_Delete: 'Delete',
    DDB_Character_Edit: 'Edit',
    DDB_Character_LeaveCampaign: 'Leave Campaign',
    DDB_Character_View: 'View',

    DDB_ListingFilter_SearchChanged: 'Search Changed',
    DDB_ListingFilter_SearchCleared: 'Search Cleared',

    DDB_ListingSort_Changed: 'Changed',

    DDB_PlayerAppBanner_Dismissed: 'Dismissed',
    DDB_PlayerAppBanner_ClickedCta: 'Clicked CTA',

    DDB_Unlock_CharacterLocked: 'Character Locked',
    DDB_Unlock_CharacterUnlocked: 'Character Unlocked',
    DDB_Unlock_FinishUnlockingClicked: 'Finish Unlocking Clicked',
    DDB_Unlock_FinishUnlockingCancelled: 'Finish Unlocking Cancelled',
    DDB_Unlock_FinishUnlockingConfirmed: 'Finish Unlocking Confirmed',
    DDB_Unlock_SubscribeClicked: 'Subscribe Clicked',
};

export const EventLabels = {
    Cancelled: 'Cancelled',
    Clicked: 'Clicked',
    Confirmed: 'Confirmed',
};
